"use strict";
'kiwi public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: ['ircinput', 'closeInputTool'],
  data() {
    return {
      groups: [{
        name: 'recientes',
        icon: '🕘',
        emojis: ['😀', '😂', '🤣', '😍', '😘', '😎', '😊', '😉', '👍', '❤️', '🔥', '💯', '🙏', '👏', '🎉', '😡']
      }, {
        name: 'caras',
        icon: '😀',
        emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😍', '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐', '😕', '😟', '🙁', '☹️', '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '🥱', '😤', '😡', '😠', '🤬', '😈']
      }, {
        name: 'manos',
        icon: '👍',
        emojis: ['👍', '👎', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '🤝', '👏', '🙌', '👐', '🤲', '🙏', '✍️', '💅', '🤳', '💪', '🦾', '🖕']
      }, {
        name: 'amor',
        icon: '❤️',
        emojis: ['👀', '👁️', '👅', '👄', '💋', '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '💤', '💢', '💥', '💫', '💦', '💨', '💣', '💬']
      }, {
        name: 'animales',
        icon: '🐻',
        emojis: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐒', '🐔', '🐧', '🐦', '🐤', '🐣', '🐥', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐞', '🐜', '🦟', '🐢', '🐍', '🦎', '🦂', '🦀', '🐙', '🦑', '🐠']
      }, {
        name: 'comida',
        icon: '🍔',
        emojis: ['☕', '🍵', '🧉', '🍺', '🍻', '🥂', '🍷', '🍸', '🍹', '🍾', '🍕', '🍔', '🍟', '🌭', '🥪', '🌮', '🌯', '🥙', '🍝', '🍜', '🍲', '🍛', '🍣', '🍤', '🍦', '🍧', '🍨', '🍩', '🍪', '🎂', '🍰', '🧁', '🍫', '🍬', '🍭', '🍿', '🍎', '🍊', '🍌', '🍉']
      }, {
        name: 'objetos',
        icon: '💡',
        emojis: ['🔥', '✨', '⭐', '🌟', '💯', '✅', '❌', '⭕', '❗', '❓', '⁉️', '🎵', '🎶', '🎧', '🎤', '🎸', '🎹', '🥁', '🎷', '🎺', '🎮', '🎲', '🎯', '🎁', '🎉', '🎊', '💡', '📱', '💻', '⌚', '📷', '📌']
      }, {
        name: 'deporte',
        icon: '⚽',
        emojis: ['⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🎱', '🏓', '🏸', '🥊', '🥋', '🥅', '🏆', '🥇', '🥈', '🥉', '🚗', '🚕', '🚙', '🚌', '🏍️', '🚲', '✈️', '🚀', '🌍', '🌎', '🌏', '🌹', '🌷', '🌺', '🌸', '🌼']
      }]
    };
  },
  computed: {
    allEmojis() {
      let seen = new Set();
      let all = [];
      this.groups.forEach(group => {
        group.emojis.forEach(emoji => {
          if (!seen.has(emoji)) {
            seen.add(emoji);
            all.push(emoji);
          }
        });
      });
      return all;
    }
  },
  methods: {
    insertEmoji(emoji) {
      if (this.ircinput && typeof this.ircinput.insertText === 'function') {
        this.ircinput.insertText(emoji);
      }
      if (typeof this.closeInputTool === 'function') {
        this.closeInputTool();
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["Emoji"]
window._kiwi_exports.components.inputtools.Emoji = exports.default ? exports.default : exports;
